export enum ValidationErrorMessage {
  MustBePresent  = 'Must be present',
  InvalidClearTrigger = "Cannot erase a value for required property",
  InvalidDate = 'Invalid date',
  MustBeDefined = 'Must be defined',
  IncompleteCondtional = 'Incomplete conditional rule(s)',
}
